<!-- A business's own setting wins over AI › Feature switches, both ways. -->
<section class="panel features-panel">
  <div class="section-header">
    <h3>Features</h3>
  </div>

  @if (loading && rows.length === 0) {
    <span class="muted">Loading features…</span>
  } @else if (unavailable) {
    <span class="muted">{{ unavailable }}</span>
  } @else {
    @if (error) {
      <div class="note note-err">{{ error }}</div>
    }
    <p class="muted features-hint">A business follows AI › Feature switches unless it is set here. A setting here wins.</p>
    @for (row of rows; track row.key) {
      <div class="feature-row" [attr.data-key]="row.key">
        <div class="feature-text">
          <div class="feature-title">
            <strong>{{ row.name }}</strong>
            <span class="pill" [class.pill-green]="row.enabled" [class.pill-red]="!row.enabled">{{ row.enabled ? 'On' : 'Off' }}</span>
          </div>
          <div class="muted">{{ row.covers }}</div>
          @if (row.updatedAt) {
            <div class="muted updated">Set {{ utc(row.updatedAt) | date:'d MMM y, HH:mm':'UTC' }} UTC by {{ row.updatedBy || '—' }}</div>
          }
        </div>
        <label class="feature-choice">
          <span class="sr-only">{{ row.name }} for this business</span>
          <select class="inp" [ngModel]="pending?.row?.key === row.key ? pending!.choice : choiceOf(row)" [disabled]="saving"
                  (ngModelChange)="choose(row, $event)">
            <option value="follow">{{ label(row, 'follow') }}</option>
            <option value="on">{{ label(row, 'on') }}</option>
            <option value="off">{{ label(row, 'off') }}</option>
          </select>
        </label>
      </div>

      @if (pending?.row?.key === row.key) {
        <div class="note note-warn feature-confirm">
          Set {{ row.name }} to <strong>{{ label(row, pending!.choice) }}</strong>?
          {{ pendingEffect }}
          <div class="confirm-actions">
            <button type="button" class="act-ghost act-sm" [disabled]="saving" (click)="cancel()">Cancel</button>
            <button type="button" class="act act-sm confirm-btn" [disabled]="saving" (click)="confirm()">{{ saving ? 'Saving…' : 'Yes, change it' }}</button>
          </div>
        </div>
      }
    }
  }
</section>
